import {
  type ApiRoleStrategy,
  ROLES,
  useResourceListApi,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { formatMyNotification } from "./formatMyNotification"
import type { ApiNotification, AppNotification } from "./notification.model"

export const useMyNotifications = ({
  size,
  pharmacyId,
}: {
  size?: number
  pharmacyId?: string
}) => {
  const { endpoint, queryKey } = useRoleConf(notificationRoleConf(pharmacyId))

  const {
    list: notifications = [],
    paginationProps,
    initialLoading,
  } = useResourceListApi<ApiNotification, AppNotification>({
    resourceEndpoint: endpoint,
    queryKey,
    rowsPerPage: size,
    select: formatMyNotification,
  })

  return {
    notifications,
    count: paginationProps.count,
    isLoading: initialLoading,
  }
}

const adhNotificationConf = {
  endpoint: "/api/notifications/my",
  queryKey: ["notification", "my"],
}

const notificationRoleConf = (pharmacyId?: string): ApiRoleStrategy => ({
  [ROLES.ADHERENT_HOLDER]: adhNotificationConf,
  [ROLES.ADHERENT_TEAM]: adhNotificationConf,
  ...(pharmacyId && {
    [ROLES.ADHERENT_ADVISOR]: {
      endpoint: `/api/notifications/my-sector/adherent/${pharmacyId}/`,
      queryKey: ["notification", "my-sector", "adherent", pharmacyId],
    },
    [ROLES.ADMIN]: {
      endpoint: `/api/notifications/adherent/${pharmacyId}/`,
      queryKey: ["notification", "adherent", pharmacyId],
    },
  }),
})
